import { Field, InputType } from 'type-graphql'

@InputType()
export class SaveDriverSettingsInput {
  @Field(() => Boolean, { nullable: true })
  aiVoiceExtractionEnabled?: boolean

  @Field(() => Boolean, { nullable: true })
  aiManifestExtractionEnabled?: boolean
}
